import React from 'react'
import { BibliographyB1Copy } from '@chegg-wt/core/types/copy'
import { LvpMarginWrapper } from '../../Layouts/LargeVideoPlayerLayout'
import * as Styled from './styled'

interface Props {
  copy: BibliographyB1Copy
}

const BibliographyB1: React.FunctionComponent<Props> = ({ copy }) => (
  <LvpMarginWrapper>
    <Styled.Container>
      <Styled.HeadingContainer>
        <Styled.ContentHeading>{copy.title}</Styled.ContentHeading>
      </Styled.HeadingContainer>
      <div>
        {copy.contents.map((content) => (
          <React.Fragment key={content.header}>
            <Styled.Header>{content.header}</Styled.Header>
            <Styled.Body>{content.body}</Styled.Body>
          </React.Fragment>
        ))}
      </div>
    </Styled.Container>
  </LvpMarginWrapper>
)

export default BibliographyB1
